import { Box, Typography } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import WindowsIconLarge from "assets/logos/windowsIconLarge.svg";

const sx = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    height: "100vh",
    padding: "40px"
  },

  windowsIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    padding: "20px"
  }
};

export default function MobileBlockerScreen() {
  return (
    <Box sx={sx.container}>
      <Typography variant="h6" sx={{ color: (theme) => theme.palette.blue.c100 }}>
        The Markaaz Enterprise Portal is better on desktop!
      </Typography>
      <Box sx={sx.windowsIconContainer}>
        <img src={WindowsIconLarge} alt="windowsIcon" />
      </Box>
      <Typography variant="body2" sx={{ color: (theme) => theme.palette.darkBlue.c70, pb: "20px" }}>
        We're currently optimizing our mobile experience. Please use the URL below to access the full features of the
        Markaaz Enterprise Portal on your desktop.
      </Typography>
      <MzButton>enterprise-partner-portal.app.markaaz.com</MzButton>
    </Box>
  );
}
